import * as yup from "yup";
import { TFunction } from "i18next";
import { ValidationMessagesUtils } from "../../../utils/yup";

export default function quoteRequestEdit(t: TFunction) {
  return yup.object().shape({
    items: yup.array().of(
      yup.object().shape({
        cost: yup
          .number()
          .required(
            ValidationMessagesUtils.createRequiredMessage(t, "costing.cost")
          ),
      })
    ),
  });
}
